import { Checkbox, Text } from '@audio-network/componentlibrary'
import React, { useState } from 'react'

import CheckboxList from '../CheckboxList/CheckboxList'
import CheckboxListItem from '../CheckboxListItem/CheckboxListItem'
import { ShowAll } from '@audio-network/componentlibrary/icons'
import { SimpleFilterProps } from './SimpleFilter.types'
import styles from './SimpleFilter.module.css'
import { useRefinementList } from 'react-instantsearch'
import { useRefinements } from '../../CurrentRefinements/CurrentRefinements.hooks'
import { useTranslation } from 'next-i18next'

const SimpleFilter = ({
	attribute,
	curatedFacets,
	...props
}: SimpleFilterProps): JSX.Element => {
	const { t } = useTranslation(['search'])

	const [showAll, setShowAll] = useState(false)

	const toggleAll = (): void => {
		setShowAll(!showAll)
	}

	const { items, refine } = useRefinementList({
		attribute,
		operator: 'and',
		sortBy: ['name'],
		limit: 56111, //Force it to show all
	})

	const { refinements: allRefinements } = useRefinements()

	const showCount = allRefinements.length > 0

	const visibleCuratedFacets =
		curatedFacets &&
		items?.filter((item) =>
			curatedFacets.some(
				(facet) => facet.id === item.value.toLowerCase() ?? item.isRefined //ROGUE
			)
		)

	const visibleItems =
		visibleCuratedFacets?.length > 0 && !showAll ? visibleCuratedFacets : items

	return (
		<div className={styles.simpleFilter} {...props}>
			{items?.length > 0 ? (
				<>
					<CheckboxList
						className={curatedFacets == undefined ? '' : styles.listWithShowAll}
					>
						{visibleItems.map((item) => (
							<CheckboxListItem
								key={item.value}
								data-testid={`${item.value}-item`}
							>
								<Checkbox
									label={
										<>
											{item.label}
											{showCount && (
												<span className={styles.count}>&nbsp;{item.count}</span>
											)}
										</>
									}
									name={item.value}
									checked={item.isRefined}
									onChange={() => {
										refine(item.value)
									}}
								/>
							</CheckboxListItem>
						))}
					</CheckboxList>
					{curatedFacets && (
						<button
							className={styles.showMoreButton}
							disabled={visibleCuratedFacets?.length === 0}
							onClick={toggleAll}
						>
							<ShowAll />
							{showAll || visibleCuratedFacets?.length === 0
								? t('show-fewer')
								: t('show-more')}
						</button>
					)}
				</>
			) : (
				<Text className={styles.noFiltersMessage}>{t('no-filters')}</Text>
			)}
		</div>
	)
}

export default SimpleFilter
